import React from "react";

const MeetingDetails = () => {
  return <div>MeetingDetails</div>;
};

export default MeetingDetails;
